import {Component,OnInit,Input,Output,EventEmitter,ElementRef,ViewChild,IterableDiffers,HostListener} from '@angular/core';
import { FormGroup} from '@angular/forms';
import { Subscription } from 'rxjs';

import { Message } from '../model/asd/asd-properties/asd-message';
import { FormBase } from '../model/form/form';
import { FormMessage } from '../model/form/form-properties/form-message';
import { InterfaceElement } from '../model/asd/asd-properties/asd-ie/asd-interfaceElement';

import { InterfaceElementTypes } from '../model/interfaceElement/interfaceElement-properties/interfaceElement-type';
import { InterfaceElementCosyDataTypes } from '../model/interfaceElement/interfaceElement-properties/interfaceElement-cosytype';
import { InterfaceElementDataTypes } from '../model/interfaceElement/interfaceElement-properties/interfaceElement-datatype';
import { DownloadFile } from '../model/asd/asd-properties/asd-downloadFile';
import { AppConfig } from '../app.config';
import { UXControllerService } from '../service/controller/ux-controller.service';
import { CosyCollectionComponent } from '../cosy-collection/cosy-collection.component';
import { BreadCrumbItem } from '../model/breadCrumb/breadCrumbItem';

@Component({
  selector: 'app-cosy-html',
  templateUrl: './cosy-html.component.html',
  styleUrls: ['./cosy-html.component.css']
})
export class CosyHtmlComponent implements OnInit {
  @Input() ieList: InterfaceElement[] = [];
  @Input() subscriptions;
  @Input() viewAreaTemplateID;
  @Input() viewAreaName;
  @Input() sessionID;
  @Input() isFromRibbon;
  @Input() downloadFile: DownloadFile;
  @Input() cosyFormInit: FormBase;
  @Input() breadCrumb: BreadCrumbItem[] = [];
  @Input() languageOptions : any[]=[];
  @Output() userActiontoProcess: EventEmitter<any> = new EventEmitter<any>();
  @Output() loadHistory: EventEmitter<any> = new EventEmitter<any>();
  @Output() interfaceCommunicatorProps: EventEmitter<any> = new EventEmitter<any>();
  @Output() switchToApp: EventEmitter<any> = new EventEmitter<any>();    
  @Output() switchToAppCall: EventEmitter<any> = new EventEmitter<any>(); 
  @ViewChild('iesearch') iesearch: ElementRef;
  @ViewChild('CosyCollectionComponent') cosyCol: CosyCollectionComponent;
  @HostListener('window:resize', ['$event'])
  onResize(event?) { }
  @Output() message: EventEmitter<Message> = new EventEmitter<Message>();

  public classVA: string = "";
  public ieSearchType: InterfaceElement = new InterfaceElement();
  private uxControllerProps = new FormBase();

  public searchText: string = '';
  public finalDynaEditorResult: any = [];
  public processedItems: any = [];
  public captchaKey;

  public loadingToDisplay: boolean = false;
  public loading = true;
  public isDetailViewClicked: boolean = false;

  private IE_TYPES = InterfaceElementTypes;
  private IE_COSY_TYPES = InterfaceElementCosyDataTypes;
  private FORM_MESSAGE = FormMessage;
  private iterableDiffer;
 
  public group: FormGroup;

  constructor(
    private uxControllerService: UXControllerService,
    private config: AppConfig,
    private iterableDiffers: IterableDiffers,

  ) {
    this.iterableDiffer = this.iterableDiffers.find([]).create(null);

  }

  
  ngOnInit() {
    this.classVA = "row "+ this.viewAreaName;
    this.captchaKey = this.config.getConfig('captchaKey');
   
    if(this.isFromRibbon){
      for(let ie of this.ieList){
        ie.isFromRibbon = true;
      }
    }
  }

  ngAfterContentInit() {
    if (this.uxControllerService.cosyFormInitProperties != null) {
      this.uxControllerProps = this.uxControllerService.cosyFormInitProperties.UXControllerProperties;
    }
  }

  ngOnDestroy() {
    if(this.subscriptions!= null){
      this.subscriptions.unsubscribe();
    }
  }

  switchToAppAction(){
    this.switchToApp.emit();
  }
  switchToAppChildAction(){
    this.switchToAppCall.emit();
  }

  loadHistorytoBreadCrumb(sessionID: any){
    this.loadHistory.emit(sessionID);
  }
}
